import type { ProductType } from '@atlassian/search-client';

import { productCategories, ProductCategoryKey } from '../constants/product-categories';
import { type ProductKeys, products, PRODUCTS_ORDER } from '../constants/products';

/**
 * Get product display name from product key
 * @param type product key
 * @returns product display name
 */
export const getProductDisplayName = (type?: ProductType) => {
	switch (type) {
		case 'jira':
			return 'Jira';
		case 'confluence':
			return 'Confluence';
		case 'townsquare':
			return 'Atlas';
		case 'drive':
			return 'Google Drive';
		case 'microsoft':
		case 'sharepoint':
			return 'Microsoft SharePoint';
		case 'github':
			return 'GitHub';
		case 'compass':
			return 'Compass';
		case 'trello':
			return 'Trello';
		case 'mercury':
			return 'Focus';
	}
	return '';
};

/**
 * Given a product key, returns whether or not a product is a 3P
 * @param product
 * @returns Whether or not a product is a 3P
 */
export const isProduct3P = (product: ProductKeys) => {
	return products[product].is3P;
};

export const omitAtlasProductKeys = (productKeys: ProductKeys[]) => {
	const atlasProducts = productCategories[ProductCategoryKey.Atlas].products;
	return productKeys.filter((productKey) => !atlasProducts.includes(productKey));
};

export const getProductOrder = (a: ProductKeys, b: ProductKeys) => {
	const indexA = PRODUCTS_ORDER.indexOf(a);
	const indexB = PRODUCTS_ORDER.indexOf(b);

	if (indexA === -1 || indexB === -1) {
		return 0;
	} else {
		return indexA - indexB;
	}
};
